const randomWords = require('random-words');
const _ = require('lodash')
export const words = _.uniq(randomWords({exactly: 2000, maxLength: 10}).sort())